import React 			from 'react';
import PropTypes 		from 'prop-types';
import BLComponent 		from '../core/_BLComponent.jsx';

import FloatingImage 	from '../common/_FloatingImage.jsx';
import HiddenScroll 	from '../common/_HiddenScroll.jsx';
import {CustomConfirm, CustomAlert, ClickShowTooltip}	from '../common/_Utilities.jsx';
import CustomCheckbox from '../common/_CustomCheckbox.jsx';
import DSAReportButton from '../common/_DSAReportButton.jsx';

import ZoomModal 		from '../modals/_ZoomModal.jsx';
import {HoverShowTooltip, HoverHideTooltip}	from '../common/_Utilities.jsx';

export default class CommentsSection extends BLComponent 
{

	constructor(props, context) 
	{
		super(props, context);

		this.state = 
			{
				dummy:					0
			,	authoringCommentType: 	0
			,	attachment: 			{}
			,	myComment: 				''
			,	activeFilter: 			99
			,	showZoomModal: 			false
			,	mode:					this.props.mode ? this.props.mode : 0
			,	showVerifiedBuyer: 		false
			,	modelCommentFilter:		0
			,	uploadingFiles: []
			,	isReporting: false
			,	watchingComment: null
			};

		const	me	= blapp.session.getMe();

		this.isAdmin 	= 	( me && me.bIsActingAdmin );
		this.comments	= 	{
								"ALL":			{ nTotalCnt: 0, list: [], idCommentLast: 0, nTotalFilteredCnt: 0 }
							,	"COMMENT":		{ nTotalCnt: 0, list: [], idCommentLast: 0 }
							,	"REVIEW":		{ nTotalCnt: 0, list: [], idCommentLast: 0 }
							,	"INSTRUCTIONS":	{ nTotalCnt: 0, list: [], idCommentLast: 0 }
							};
		this.filterMap	=	{
								0:	"COMMENT"
							,	1:	"REVIEW"
							,	2:	"INSTRUCTIONS"
							,	99:	"ALL"
							}
		this.typeComment = null;
		this.reportArea = null;

		if(this.props.mode == 1 & this.props.special == 'bdp_series') {
			this.typeComment = 'bdp';
			this.reportArea = "BDPProductDetailsPage";
		}
		else if(this.props.mode == 1 & this.props.special == 'mps') {
			this.typeComment = 'mps';
		}
		else if(this.props.mode == 1) {
			this.typeComment = 'gallery';
			this.reportArea = "StudioGallery";
		} 
		else {
			this.typeComment = 'catalogItem'
		}

		this.fetchInitialComments( false );

		this.reportedComments = [];
		// this.fetchReportedComments()
	}


	componentDidMount()
	{
		blapp.session.onSessionUpdate( this.onSessionUpdate );
	}

	componentWillUnmount() 
	{ 
		super.componentWillUnmount(); 
		blapp.session.offSessionUpdate( this.onSessionUpdate );
	}	

	onSessionUpdate = () =>
	{
		const	me	= blapp.session.getMe();
		
		this.isAdmin 	= 	( me && me.bIsActingAdmin );

		this.setState( { dummy: this.state.dummy + 1 } );
	}

	render() 
	{
		const {classes = "", isTightMobile = false, isDisabled, isClosed = false} = this.props;
		return (
			<section className={classes + (isTightMobile ? ' comments-container--tight-mobile' : '')}>
				{this.state.showZoomModal ? this.renderZoomModal() : null}
				{isDisabled ? this.renderDisabled() : isClosed ? this.renderClosed() : this.renderCommentForm()}
				{this.renderCommentsFilter()}
				{this.renderCommentItems()}
			</section>
		);
	}

	renderCommentForm() 
	{
		let	attachmentPreviewElem	= null;
		if ( this.state.attachment && this.state.attachment.filename )
		{
			const	filename	= this.state.attachment.filename.toLowerCase();
			const	imgExt		= [ ".jpg", ".jpeg", ".gif", ".png" ];

			if ( _.find( imgExt, ( ext ) => filename.endsWith( ext ) ) )
			{
				attachmentPreviewElem	= ( <FloatingImage classes="comments-form__attachment"><img src={this.state.attachment.url}/></FloatingImage> );
			}
		}

		let tabCount = 3;

		if(this.props.noComments) {
			tabCount--;
		}
		if(this.props.noReview) {
			tabCount--;
		}
		if(this.props.noInstructions) {
			tabCount--;
		}

		return (
			<div className={"comments-form" + (tabCount <= 1 ? ' comments-form--simple' : '')}>
				<ul className="comments-form__type-selector">
					{this.props.noComments ? null : <li className={"comments-form__type-selector-item" + (this.state.authoringCommentType == 0 ? " comments-form__type-selector-item--active" : '')}><button className="comments-form__type-selector-item-internal" onClick={() => this.setState({authoringCommentType: 0})}><i className="far fa-comment comments-form__type-selector-item-icon"/>Comment</button></li>}
					{this.props.noReview ? null : <li className={"comments-form__type-selector-item" + (this.state.authoringCommentType == 1 ? " comments-form__type-selector-item--active" : '')}><button className="comments-form__type-selector-item-internal" onClick={() => this.setState({authoringCommentType: 1})}><i className="far fa-star comments-form__type-selector-item-icon"/>Review</button></li>}
					{this.props.noInstructions ? null : <li className={"comments-form__type-selector-item" + (this.state.authoringCommentType == 2 ? " comments-form__type-selector-item--active" : '')}><button className="comments-form__type-selector-item-internal" onClick={() => this.setState({authoringCommentType: 2})}><i className="far fa-book-open comments-form__type-selector-item-icon"/>Instructions</button></li>}
				</ul>
				<div className="comments-form__main">
					<textarea className="textarea textarea--tall l-full-width" placeholder={$T("WRITE_SOMETHING")} value={this.state.myComment} onChange={(e) => this.setState({myComment: e.target.value})}></textarea>
				</div>
				<div className={"comments-form__footer" + (this.props.isVerifiedBuyer ? ' comments-form__footer--verified' : '') + (this.props.noAttachment ? ' comments-form__footer--no-attachment' : '')}>
					{this.props.noAttachment ? null : 
						<div className="comments-form__footer-attachment">
							{this.state.attachment && this.state.attachment.token ?
									<div className="l-flex">
										{attachmentPreviewElem ? attachmentPreviewElem : null}
										<div className={attachmentPreviewElem ? 'l-margin-left' : ''}>
											<div>{this.state.attachment.filename}</div>
											<button className="btn btn--link" onClick={() => this.removeAttachment()}>{$T("REMOVE_ATTACHMENT")}</button>
										</div>
									</div>
							:
								this.state.uploadingFiles.length > 0 ?
									<div>Uploading...</div>
							:
								<label className="btn btn--link"><input type="file" className="l-hide" onChange={(e)=>this.onAttachment(e)} /><i className="far fa-paperclip l-margin-right--sm"/>{$T("ADD_ATTACHMENT")}</label>
							}
							{this.props.isVerifiedBuyer ? 
								<div className="l-flex l-margin-top comments-form__footer-verified-check">
									<CustomCheckbox id="verified-buyer-check" isChecked={this.state.showVerifiedBuyer} onChangeFunc={() => this.setState({showVerifiedBuyer: !this.state.showVerifiedBuyer})}/>
									<span className="l-pad-left"><label htmlFor="verified-buyer-check">{$T('VERIFIED_BUYER_MESSAGE')}</label><i className="fas fa-info-circle l-pad-left--sm" data-tooltip={$T("VERIFIED_BUYER_TOOLTIP")} data-tooltip-width={150} onClick={(e) => ClickShowTooltip(e)}/></span>
								</div>
							: null}
						</div>
					}
					<button className={`btn btn--cta`} type="submit" onClick={() => this.submitComment()}>{this.renderPostPhrase()}</button>
				</div>
			</div>
		);
	}

	renderDisabled() {
		const isBDP = this.props.special == 'bdp';

		return (
			<div className="comments-disabled">
				<strong>{!isBDP ? "Comments are disabled." : "Comments are disabled for this project."}</strong>
			</div>
		);
	}
	renderClosed() {
		return (
			<div className="comments-disabled">
				<strong>Comments for this project are closed.</strong>
			</div>
		);
	}

	renderPostPhrase() 
	{
		switch( this.state.authoringCommentType ) 
		{
			case 0:		return $T("POST_COMMENT");
			case 1:		return $T("POST_REVIEW");
			case 2:		return $T("POST_INSTRUCTIONS");
		}
	}

	renderCommentsFilter() 
	{
		const all				= this.comments[ "ALL" ];
		const commentsOnly		= this.comments[ "COMMENT" ];
		const reviewsOnly 		= this.comments[ "REVIEW" ];
		const instructionsOnly 	= this.comments[ "INSTRUCTIONS" ];

		//if ( all.nTotalCnt > 0 || commentsOnly.nTotalCnt > 0 || reviewsOnly.nTotalCnt > 0 || instructionsOnly.nTotalCnt > 0 ) 
		{
			return (
				<div className="comments-filter">
					{this.state.mode != 1 ? 
						<HiddenScroll>
							<ul className="view-selector">
								<li className={"comments-filter__item view-selector__item " + (this.state.activeFilter == 99 ? 'view-selector__item--active' : '')} onClick={() => this.changeFilter(99)}>
									<span className="view-selector__item-content">{this.props.noReview && this.props.noInstructions ? 'Comments' : 'All'} ({all.nTotalCnt})</span>
								</li>
								<li className={"comments-filter__item view-selector__item " + (this.state.activeFilter == 0 ? 'view-selector__item--active' : '')} onClick={() => this.changeFilter(0)}>
									<span className="view-selector__item-content">Comments {commentsOnly.nTotalCnt ? `(${commentsOnly.nTotalCnt})` : null}</span>
								</li>
								<li className={"comments-filter__item view-selector__item " + (this.state.activeFilter == 1 ? 'view-selector__item--active' : '')} onClick={() => this.changeFilter(1)}>
									<span className="view-selector__item-content">Reviews {reviewsOnly.nTotalCnt ? `(${reviewsOnly.nTotalCnt})` : null}</span>
								</li>
								<li className={"comments-filter__item view-selector__item " + (this.state.activeFilter == 2 ? 'view-selector__item--active' : '')} onClick={() => this.changeFilter(2)}>
									<span className="view-selector__item-content">Instructions {reviewsOnly.nTotalCnt ? `(${instructionsOnly.nTotalCnt})` : null}</span>
								</li>
							</ul>
						</HiddenScroll>
					:
						<HiddenScroll>
							<ul className="view-selector">
								<li className={"comments-filter__item view-selector__item " + (this.state.modelCommentFilter == 0 ? 'view-selector__item--active' : '')} onClick={() => this.changeModelFilter(0)}>
									<span className="view-selector__item-content">{this.props.noReview && this.props.noInstructions ? 'All comments' : 'All'} ({all.nTotalCnt})</span>
								</li>
								{
									all.nTotalCommentsVerifiedBuyer > 0 ? 
									<li className={"comments-filter__item view-selector__item " + (this.state.modelCommentFilter == 1 ? 'view-selector__item--active' : '')} onClick={() => this.changeModelFilter(1)}>
										<span className="view-selector__item-content">Verified buyer ({all.nTotalCommentsVerifiedBuyer})</span>
									</li>
									: 
									null
								}
								{this.props.noAttachment ? null : 
									<li className={"comments-filter__item view-selector__item " + (this.state.modelCommentFilter == 2 ? 'view-selector__item--active' : '')} onClick={() => this.changeModelFilter(2)}>
										<span className="view-selector__item-content">Comments with images ({all.nTotalCommentsWithImage})</span>
									</li>
								}
							</ul>
						</HiddenScroll>
					}
				</div>
			);
		}
	}

	renderCommentItems() 
	{
		const	watchingComment = this.state.watchingComment;
		const	me				= blapp.session.getMe()
		const	imgExt		= [ "jpg", "jpeg", "gif", "png" ];
		const	selected	= this.comments[ this.filterMap[ this.state.activeFilter ] ]
		const	comments	= watchingComment ? _.concat( [ watchingComment ], selected.list ) : selected.list;
		const	showBoost	= this.state.mode == 0 && me && ( me.bIsActingAdmin || me.typeUser == 3 );
		const	showReport	= this.props.hasModerationFlag && me != null;
		
		if ( comments.length ) 
		{
			return (
				<div className="comments">
				{
					comments.map(
						(comment, key) => 
						{
							let		attachElem	= null;
							const	showDelete	= this.isAdmin || ( comment._dmUser && me && me.idUser == comment._dmUser.idUser ); 
							const	showToggleHide = this.isAdmin || (me && me.typeUser == 6);

							if ( comment.attachment && comment.attachment.strExtension )
							{
								const	ext	= comment.attachment.strExtension.toLowerCase()
								
								if ( ext == "pdf" )
								{
									attachElem	= <a href={comment.attachment.url} target="_blank" className="btn btn--grey l-block"><i className="fas fa-eye l-margin-right"/>View {comment.type == 2 ? "instructions" : "attachment"}</a>;
								}
								else if ( _.find( imgExt, ( e ) => ( ext == e ) ) )
								{
									attachElem	= (	<div className="comments__item-attachment" onClick={() => this.triggerZoomModal(comment.id)}>
														<FloatingImage>
															<img src={comment.attachment.url}/>
														</FloatingImage>
													</div> );
								}
								else
								{
									attachElem	= <a href={comment.attachment.url} target="_blank" className="btn btn--grey l-block"><i className="fas fa-download l-margin-right"/>Download attachment</a>;
								}
							}
							const country = comment._dmUser ? blapp.country.get(comment._dmUser.codeCountry) : null;
							const state 	= comment._dmUser ? blapp.country.getStateLegacy(comment._dmUser.idState) : null;
							let extraFlag = country && country.codeCountry == 'UK' && state;

							// const hasNotified = comment.bReported || this.reportedComments.includes(comment.id);

							const isAuthor = this.returnIsAuthor(comment);
							const isWatchingComment = ( comment.isWatchingComment === true );

							return (
								<article className={"comments__item" + (comment.boosted ? " comments__item--boosted" : "") + (isAuthor ? ' comments__item--builder' : '') + (comment.bHidden ? ' comments__item--hidden' : '')} key={ isWatchingComment ? -1*comment.id : comment.id } style={isWatchingComment ? {backgroundColor: '#ffb266' } : null}>
									<div className="comments__side-col">
										<div className="comments__item-user-image">
											<img className="comments__item-user-image-item" src={comment.profileImage}/>
										</div>
										<header className="comments__item-side-col-info">
											{this.renderLabel(comment)}
											<strong className="comments__item-author l-block">{comment.author}</strong>
											{country &&
												<div className="comments__item-author-location">
													{extraFlag ? <img src={blapp.url2.getCountryFlagUrl(state.idStateLegacy)}/> : null}
													<img src={blapp.url2.getCountryFlagUrl(country.codeCountry)}/>{state ? `${state.strStateName}, ` : null} {country.strCountryName}
												</div>
											}
										</header>
									</div>
									<div className="comments__item-details">
										<header className="comments__item-header">
											{this.renderLabel(comment)}
											<strong className="comments__item-author l-block">{comment.author}{ ( this.state.mode == 0 && comment.userRank == 99 ) ? <i className="far fa-key-skeleton comments__item-admin"/> : null}</strong>
											{country &&
											<div className="comments__item-author-location">
												{extraFlag ? <img src={blapp.url2.getCountryFlagUrl(state.idStateLegacy)}/> : null}
												<img src={blapp.url2.getCountryFlagUrl(country.codeCountry)}/>{state ? `${state.strStateName}, ` : null} {country.strCountryName}
											</div>
											}
										</header>
										<div className="comments__item-meta">
											{comment.type != 0 ? this.renderCommentType(comment.type) : null}
											<div className="l-flex l-start l-full-width">
												<span className="comments__item-posted">{comment.posted}</span>
												{ this.reportArea ? <DSAReportButton classes="btn comments__report-button" reportArea={this.reportArea} contentType="Comment" contentId={comment.id} contentUrl="self"><div className="l-flex l-center text--small"><i className="far fa-flag l-margin-right--sm"/><span>Report</span></div></DSAReportButton> : null }
												{/* {showReport ? <button className={`comments__item-flag ${hasNotified ? 'comments__item-flag--reported' : ''} js-bottom-right-tooltip`} onClick={() => !this.state.isReporting && this.reportComment(comment.id)} data-tooltip={hasNotified ? 'You have reported this comment to our Admins' : `Report this comment to our Admins`} data-tooltip-width={150} onMouseOver={(e) => HoverShowTooltip(e)} onMouseLeave={(e) => HoverHideTooltip(e)}><i className="far fa-flag l-margin-right--sm"/>Report</button> : null} */}
											</div>
										</div>
										<div className="comments__item-content" dangerouslySetInnerHTML={{__html: this.formatWithLinks(comment.content)}}/>
										{
											comment.attachment || showDelete || showBoost || showToggleHide ? 
											<footer className="comments__item-footer">
												{this.props.noAttachment ? null : attachElem}
												{showDelete || showBoost || showToggleHide ? 
													<div className="comments__admin-tools">
														{/* {showToggleHide ? <button className="comments__admin-tools-item btn btn--blank" onClick={() => this.toggleComment(comment)}><i className={`far ${!comment.bHidden ? 'fa-eye-slash' : 'fa-eye'}`}/></button> : null} */}
														{/* {showDelete ? <button className="comments__admin-tools-item btn btn--blank text-color--primaryRed" onClick={() => this.deleteComment(comment.id)}><i className="far fa-trash-alt"/></button> : null} */}
														{showBoost ? <button className="comments__admin-tools-item btn btn--blank text-color--primaryGreen" onClick={() => this.toogleBoost(comment.id, !comment.boosted )}><i className={comment.boosted ? "far fa-bookmark" : "fas fa-bookmark"}/></button> : null}
													</div>
												: null}
											</footer>
											: 
											null
										}
									</div>
								</article>
							);
						}
					)				
				}
				{(this.state.modelCommentFilter > 0 && selected.nTotalFilteredCnt > selected.list.length) || (this.state.modelCommentFilter == 0 && selected.nTotalCnt > selected.list.length) ?
					<div className="l-pad text--center">
						<button className="btn" onClick={()=>this.fetchMoreList()}>Load more comments</button>
					</div>
				:
					<div className="l-pad l-margin-top--xl text--center">
						<p>You've reached the end of the comments.</p>
					</div>
				}
				</div>
			);
		}
		else if ( this.state.mode == 1 )
		{
			const commentContent = [
					{icon: 'fal fa-comment-lines', title: 'No one has posted a comment.', tag: 'Why not be the first?'}
				,	{icon: 'fal fa-comment-lines', title: 'No verified buyer has posted a comment yet.', tag: 'Why not be the first?'}
				,	{icon: 'fal fa-comment-lines', title: 'No one has posted a comment with an image yet.', tag: 'Why not be the first?'}
			]; 

			const commentType = commentContent[this.state.modelCommentFilter];

			return (
				<div className="comments">
					<div className="l-margin-y--xl text--center">
						<i className={commentType.icon + " l-margin-bottom text-color--darkest48 l-block"} style={{fontSize: "5em"}}/>
						<strong>{commentType.title}</strong>
						<p>{commentType.tag}</p>
					</div>
				</div>
			);
		}else{
			const commentContent = [
					{icon: 'fal fa-comment-lines', title: 'No one has left a comment yet.', tag: 'Get the discussion started by posting the first one!'}
				,	{icon: 'fal fa-stars', title: 'No one has written a review yet.', tag: 'Help others decide if this item is right for them by writing the first review!'}
				,	{icon: 'fal fa-book-open', title: 'No instructions have been posted yet.', tag: 'Be the first to share instructions for this item!'}
			]; 

			if(this.state.activeFilter != 99) {			
				const commentType = commentContent[this.state.activeFilter];

				return (
					<div className="comments">
						<div className="l-margin-y--xl text--center">
							<i className={commentType.icon + " l-margin-bottom text-color--darkest48 l-block"} style={{fontSize: "5em"}}/>
							<strong>{commentType.title}</strong>
							<p>{commentType.tag}</p>
						</div>
					</div>
				);
			}
		}
	}

	renderLabel(comment) {
		const isAuthor = this.returnIsAuthor(comment);
		const notAdmins = [749764, 1927220];
		const isAdmin = comment.userRank == 99 && notAdmins.indexOf(comment._dmUser.idUser) == -1;

		if(isAdmin) {
			return (
				<div className="comments__item-label">Admin</div>
			);
		}else if(isAuthor) {
			if(this.props.special == 'bdp') {
				return (
					<div className="comments__item-label">10k Club Member</div>
				);
			}else{
				return (
					<React.Fragment>
						<div className="comments__item-label">Designer</div>
						{comment.bdpFinalist && <div className="comments__item-label comments__item-label--bdp-finalist">BDP Finalist</div>}
					</React.Fragment>
				);
			}
		}else if(comment.bdpFinalist) {
			return (
				<div className="comments__item-label comments__item-label--bdp-finalist">BDP Finalist</div>
			);
		}
	}

	returnIsAuthor(comment) {
		return this.props.item && this.props.item.idUserBuilder && comment._dmUser && comment._dmUser.idUser == this.props.item.idUserBuilder;
	}

	formatWithLinks(content) {
		const strippedContent = content.replace(/<\/?[a-z]+(?=[\s>])(?:[^>=]|=(?:'[^']*'|"[^"]*"|[^'"\s]*))*\s?\/?>/gi, '');

		const regex = /([^\S]|^)(((https?\:\/\/)|(www\.))(\S+))/gi;

		return (strippedContent || "").replace(regex,
			function(match, space, url){
				let hyperlink = url;

				if (!hyperlink.match('^https?:\/\/')) {
					hyperlink = 'http://' + hyperlink;
				}

				return space + '<a href="' + hyperlink + '" target="_blank">' + url + '</a>';
			}
		);
	};


	renderCommentType(type) 
	{
		switch(type) 
		{
		case 1:
			return <div className="comments__item-type comments__item-type--review"><i className="l-margin-right--sm fas fa-star"/>{$T("REVIEW")}</div>;

		case 2:
			return <div className="comments__item-type comments__item-type--instructions"><i className="l-margin-right--sm fas fa-book-open"/>{$T("INSTRUCTIONS")}</div>;
		}
	}

	changeFilter( newFilter )
	{
		this.setState( { activeFilter: newFilter } );
	}

	changeModelFilter( newFilter )
	{
		this.setState( { modelCommentFilter: newFilter }, ()=>this.fetchInitialComments() );
	}

	fetchInitialComments( bAppend )
	{
		const watchingCommentId = blapp.util.getHashVar( "watching_comment" );

		if ( watchingCommentId && parseInt( watchingCommentId ) > 0 && ( this.typeComment == "gallery" || this.typeComment == "bdp" ) ) {
			blapp.models.fetch(
				"_watching_comment"
				,	{
					controller:	"common.BLCComment"
				,	method:		"getComment"
				,	params:		[ this.typeComment, this.props.item.idItem, parseInt( watchingCommentId ) ]
				,	refresh:	true
				}
			).then(
				( data ) =>
				{
					if ( data && data.idComment ) {
						let cmt = this.convertComment( data );
						cmt.isWatchingComment = true;
						this.setState( { watchingComment: cmt } );
					}
				}
			).catch (
				( err ) =>
				{
					console.log( err );
				}
			);
		}

		blapp.models.fetch(
			"_comment_result"
		,	{
				controller:	"common.BLCComment"
			,	method:		"getInitialList"
			,	params:		[ this.typeComment, this.props.item.idItem, this.state.modelCommentFilter ]
			,	refresh:	true
			}
		).then(
			( data ) =>
			{
				let newComments	=	{
										"ALL":			{ nTotalCnt: data.nTotalCount, list: [], idCommentLast: 0, 
															nTotalCommentsVerifiedBuyer: data.nTotalCommentsVerifiedBuyer,
															nTotalCommentsWithImage: data.nTotalCommentsWithImage,
															nTotalFilteredCnt: this.state.modelCommentFilter == 0 ? data.nTotalCnt : this.state.modelCommentFilter == 1 ? data.nTotalCommentsVerifiedBuyer : data.nTotalCommentsWithImage }
									,	"COMMENT":		{ nTotalCnt: data.nCommentCount, list: [], idCommentLast: 0 }
									,	"REVIEW":		{ nTotalCnt: data.nReviewCount, list: [], idCommentLast: 0 }
									,	"INSTRUCTIONS":	{ nTotalCnt: data.nInstructionsCount, list: [], idCommentLast: 0 }
									};

				_.forEach(
					data.arrList
				,	( cmt ) =>
					{
						const	conv	=	this.convertComment( cmt );

						newComments[ "ALL" ].list.push( conv );
						newComments[ "ALL" ].idCommentLast	= cmt.idComment;
						if( this.state.mode == 0 ){
							newComments[ cmt.typeComment ].list.push( conv );
							newComments[ cmt.typeComment ].idCommentLast	= cmt.idComment;
						}
					}
				);

				if ( bAppend )
				{
					_.forEach(
						this.comments
					,	( selected, key ) =>
						{
							let	newSelected	= newComments[ key ];

							_.forEach( 
								selected.list 
							,	( cmt ) =>
								{
									if ( newSelected.idCommentLast > cmt.id && cmt.boosted == false )
									{
										newSelected.list.push( cmt );
										newSelected.idCommentLast	= cmt.id;
									}
								}
							);
						}
					);
				}

				this.comments	= newComments;

				this.setState( { dummy: this.state.dummy + 1 } );
			}
		).catch (
			( err ) =>
			{
				console.log( err );
			}
		);
	}

	fetchMoreList()
	{
		const	type		= this.filterMap[ this.state.activeFilter ];
		const	selected	= this.comments[ type ];
		const	filter		= this.state.mode == 0 ? type == "ALL" ? null : type : this.state.modelCommentFilter

		if ( selected.nTotalCnt > selected.list.length )
		{
			blapp.models.fetch(
				"_comment_result"
			,	{
					controller:	"common.BLCComment"
				,	method:		"getMoreList"
				,	params:		[this.typeComment, this.props.item.idItem, selected.idCommentLast, filter]
				,	refresh:	true
				}
			).then(
				( data ) =>
				{
					const	selected	= this.comments[ type ];

					_.forEach(
						data
					,	( cmt ) =>
						{
							if ( cmt.idComment < selected.idCommentLast )
							{
								const	conv	=	this.convertComment( cmt );

								selected.list.push( conv );
								selected.idCommentLast	= cmt.idComment;
							}
						}
					);
					
					this.setState( { dummy: this.state.dummy + 1 } );
				}
			).catch (
				( err ) =>
				{

				}
			)
		}		
	}

	convertComment( cmt )
	{
		const	me		= blapp.session.getMe();
		const	dmUser	= cmt.dmUserAuthor;

		return 	{
					id:				cmt.idComment
				,	author:			dmUser ? dmUser.skUsername : "(Unknown)"
				,	profileImage:	blapp.url2.getProfileImgUrl( dmUser, "large" )
				,	userRank:		dmUser ? ( ( dmUser.typeUser == 99 || dmUser.typeUser == 3 ) ? 99 : blapp.util.getLevelFromFeedbackScore( dmUser.nFeedbackScore ) ) : 0
				,	type:			this.state.mode == 0 ? cmt.typeComment == "REVIEW" ? 1 : ( cmt.typeComment == "INSTRUCTIONS" ? 2 : 0 ) : 0
				,	posted:			blapp.format.formatTimeElapsed( cmt.tsCreated )
				,	content:		cmt.strContent
				,	attachment:		cmt.dmFileAttached
				,	boosted:		cmt.isBoosted
				,	verifiedBuyer:	cmt.bVerifiedBuyer
				,	_dmUser:		dmUser
				,	bHidden:		cmt.bHidden
				,	bdpFinalist:	(cmt.dmUserBuilderStats != null && cmt.dmUserBuilderStats.listBDPBadges != null) && cmt.dmUserBuilderStats.listBDPBadges.some(b => b.strBadgeType == 'FINALIST')
				};
	}

	triggerZoomModal( id ) 
	{
		const cmt	= _.find( this.comments[ "ALL" ].list, ( cmt ) => cmt.id == id );

		if ( cmt )
		{
			this.zoomImage	= [ cmt.attachment.url ];
			this.setState({showZoomModal: true});
		}
		else
		{
			this.zoomImage	= [];
		}
	}

	renderZoomModal() 
	{
		return (
			<ZoomModal 
				data={{images: this.zoomImage}} 
				func={{toggleZoomModal: () => this.setState({showZoomModal: false})}}
			/>
		);
	}

	toggleComment(cm) {
		blapp.models.fetch( 
			"_toggle_comment"
		,	{
				controller:		"common.BLCComment"
			,	method:			cm.bHidden ? "showComment" : "hideComment"
			,	params:			[ this.typeComment, this.props.item.idItem, parseInt( cm.id ) ]
			,	refresh:		true
			}
		).then(
			( data ) =>
			{
				if ( data == "EC_OK" )
				{
					if ( this.comments[ "ALL" ].list.find(comment => comment.id == cm.id) ){
						let cmIndex =  this.comments[ "ALL" ].list.findIndex(comment => comment.id == cm.id);
						this.comments[ "ALL" ].list[cmIndex].bHidden = !this.comments[ "ALL" ].list[cmIndex].bHidden
					}
					if ( this.comments[ "COMMENT" ].list.find(comment => comment.id == cm.id) ){
						let cmIndex =  this.comments[ "COMMENT" ].list.findIndex(comment => comment.id == cm.id);
						this.comments[ "COMMENT" ].list[cmIndex].bHidden = !this.comments[ "COMMENT" ].list[cmIndex].bHidden
					}
					if ( this.comments[ "REVIEW" ].list.find(comment => comment.id == cm.id) ){
						let cmIndex =  this.comments[ "REVIEW" ].list.findIndex(comment => comment.id == cm.id);
						this.comments[ "REVIEW" ].list[cmIndex].bHidden = !this.comments[ "REVIEW" ].list[cmIndex].bHidden
					}
					if ( this.comments[ "INSTRUCTIONS" ].list.find(comment => comment.id == cm.id) ){
						let cmIndex =  this.comments[ "INSTRUCTIONS" ].list.findIndex(comment => comment.id == cm.id);
						this.comments[ "INSTRUCTIONS" ].list[cmIndex].bHidden = !this.comments[ "INSTRUCTIONS" ].list[cmIndex].bHidden
					}
					
					this.setState( { dummy: this.state.dummy + 1 } );
				}
			}
		);
	}
	deleteComment( id ) 
	{
		CustomConfirm(
			'Are you sure you want to delete this comment?'
		,	{ false: 'No', true: 'Yes, delete it'} 
		).then(
			( value ) => 
			{
				if ( value )
				{
					this.doDeleteComment( id );
				}
			}
		);
	}

	onAttachment( e )
	{
		e.preventDefault();
		e.stopPropagation();

		this.setState({uploadingFiles: e.target.files})
		blapp.fileuploader.uploadSystemTemp( 
			e.target.files
		,	( result ) => 
			{
				if ( result && result.length ==  1 )
				{
					this.setState( { attachment: result[ 0 ], uploadingFiles: [] } );
				}
			} 
		);
	}

	removeAttachment()
	{
		if ( this.state.attachment )
		{
			blapp.fileuploader.deleteFile( this.state.attachment );
			this.setState( { attachment: {} } );
		}
	}

	triggerAlert(message) {
		const confirmContent = `<i class="text-color--primaryRed fas fa-exclamation-triangle l-margin-bottom"></i>
		<p class="text-color--primaryRed">${message}</p>`;

		CustomAlert(confirmContent, 'Continue');
	}

	submitComment()
	{
		const	me		= blapp.session.getMe();
		const	content	= this.state.myComment.trim();

		if ( me == null )
		{
			if(this.props.loginModalOnly) {
				blapp.refs.get( "header" ).showLogin(
					() =>
					{
						//if ( blapp.session.isLoggedIn() )
						//	this.submitComment();
					}
				, 'onlymodal');
			}else{
				blapp.refs.get( "header" ).showLogin(
					() =>
					{
						//if ( blapp.session.isLoggedIn() )
						//	this.submitComment();
					}
				);
			}

			return;
		}
		else if ( me.statusBuyer == 1 )
		{
			this.triggerAlert( "Please confirm your email first!" );
			return;
		}
		else if ( me.statusBuyer != 0 || me.statusSeller == 2 )
		{
			this.triggerAlert( "You are not allowed to post any comment!");
			return;
		}

		if ( _.isEmpty( content ) )
		{
			this.triggerAlert( "Content is empty!" );
			return;
		}

		blapp.models.fetch(
			"_submit_comment_result"
		,	{
				controller:	"common.BLCComment"
			,	method:		"insertComment"
			,	params:		[ this.typeComment, this.props.item.idItem, this.state.myComment, _.isEmpty( this.state.attachment ) ? null : this.state.attachment,this.filterMap[ this.state.authoringCommentType ], null, this.state.showVerifiedBuyer ]
			,	refresh:	true		
			}
		).then(
			( data ) =>
			{
				if ( data == "EC_OK" )
				{
					this.setState( { myComment: "", attachment: {} } );
					this.fetchInitialComments( true );
				}
			}
		);
	}

	doDeleteComment( id )
	{
		blapp.models.fetch( 
			"_delete_comment"
		,	{
				controller:		"common.BLCComment"
			,	method:			"deleteComment"
			,	params:			[ this.typeComment, this.props.item.idItem, parseInt( id ) ]
			,	refresh:		true
			}
		).then(
			( data ) =>
			{
				if ( data == "EC_OK" )
				{
					if ( this.comments[ "ALL" ].list.find(comment => comment.id == id) && _.remove( this.comments[ "ALL" ].list, ( c ) => c.id == id ) ){
						--this.comments[ "ALL" ].nTotalCnt;
					}
					if ( this.comments[ "COMMENT" ].list.find(comment => comment.id == id) && _.remove( this.comments[ "COMMENT" ].list, ( c ) => c.id == id ) ){
						--this.comments[ "COMMENT" ].nTotalCnt;
					}
					if ( this.comments[ "REVIEW" ].list.find(comment => comment.id == id) && _.remove( this.comments[ "REVIEW" ].list, ( c ) => c.id == id ) ){
						--this.comments[ "REVIEW" ].nTotalCnt;
					}
					if ( this.comments[ "INSTRUCTIONS" ].list.find(comment => comment.id == id) && _.remove( this.comments[ "INSTRUCTIONS" ].list, ( c ) => c.id == id ) ){
						--this.comments[ "INSTRUCTIONS" ].nTotalCnt;
					}

					this.setState( { dummy: this.state.dummy + 1 } );
				}
			}
		);
	}

	toogleBoost( id, bSet )
	{
		blapp.models.fetch( 
			"_delete_comment"
		,	{
				controller:		"catalog.BLCCatalogItemComment"
			,	method:			"boostComment"
			,	params:			[ this.props.item.idItem, parseInt( id ), bSet ]
			,	refresh:		true
			}
		).then(
			( data ) =>
			{
				if ( data == "EC_OK" )
				{
					this.fetchInitialComments( true );
				}
			}
		);		
	}

	reportComment(idComment){
		this.setState({isReporting: true})
		blapp.models.fetch( 
			"_report_comment"
		,	{
				controller:		"common.BLCComment"
			,	method:			"reportComment"
			,	params:			[ this.typeComment, this.props.item.idItem, parseInt(idComment) ]
			,	refresh:		true
			}
		).then(
			( data ) =>
			{
				if ( data == "EC_OK" )
				{
					if ( this.comments[ "ALL" ].list.find(comment => comment.id == idComment) ){
						let cmIndex =  this.comments[ "ALL" ].list.findIndex(comment => comment.id == idComment);
						this.comments[ "ALL" ].list[cmIndex].bReported = true
					}
					if ( this.comments[ "COMMENT" ].list.find(comment => comment.id == idComment) ){
						let cmIndex =  this.comments[ "COMMENT" ].list.findIndex(comment => comment.id == idComment);
						this.comments[ "COMMENT" ].list[cmIndex].bReported = true
					}
					if ( this.comments[ "REVIEW" ].list.find(comment => comment.id == idComment) ){
						let cmIndex =  this.comments[ "REVIEW" ].list.findIndex(comment => comment.id == idComment);
						this.comments[ "REVIEW" ].list[cmIndex].bReported = true
					}
					if ( this.comments[ "INSTRUCTIONS" ].list.find(comment => comment.id == idComment) ){
						let cmIndex =  this.comments[ "INSTRUCTIONS" ].list.findIndex(comment => comment.id == idComment);
						this.comments[ "INSTRUCTIONS" ].list[cmIndex].bReported = true
					}
					
					this.setState( { dummy: this.state.dummy + 1 } );
				}
			}
		).finally(
			() => this.setState({isReporting: false})
		);
	}

	fetchReportedComments(){
		const	me		= blapp.session.getMe();

		if(!me || this.typeComment != 'bdp')
			return;

			blapp.models.fetch( 
				"_report_comment"
			,	{
					controller:		"common.BLCComment"
				,	method:			"getReportedComments"
				,	params:			[ this.typeComment, this.props.item.idItem ]
				,	refresh:		true
				}
			).then(
				( data ) =>
				{
					if ( data.errorCode == "EC_OK" )
					{
						
						this.reportedComments = data.data
						
						this.setState( { dummy: this.state.dummy + 1 } );
					}
				}
			);
	}
};


CommentsSection.propTypes = {
		classes: PropTypes.string
	, item: PropTypes.object
	, noComments: PropTypes.bool 
	, noReview: PropTypes.bool 
	, noInstructions: PropTypes.bool
	, mode: PropTypes.number //0: item / 1: model
	, hasVerifiedBuyer: PropTypes.bool
	, isVerifiedBuyer: PropTypes.bool
	, special: PropTypes.string //for special cases (bdp, bdp_series, mps)
	, commentsPerPage: PropTypes.number
}

var $T = BLComponent.createTextMap(
	{
		"COMMENT":
		{
			"en":	"Comment"
		,	"es":	"Comentario"
		}
	,	"REVIEW":
		{
			"en":	"Review"
		,	"es":	"Opinión"
		}
	,	"INSTRUCTIONS":
		{
			"en":	"Instructions"
		,	"es":	"Instrucciones"
		}
	,	"WRITE_SOMETHING":
		{
			"en":	"Write something"
		,	"es":	"Escribe algo"
		}
	,	"REMOVE_ATTACHMENT":
		{
			"en":	"Remove attachment"
		,	"es":	"Eliminar adjunto"
		}
	,	"ADD_ATTACHMENT":
		{
			"en":	"Add attachment"
		,	"es":	"Añadir adjunto"
		}
	,	"POST_COMMENT":
		{
			"en":	"Post comment"
		,	"es":	"Enviar comentario"
		}
	,	"POST_REVIEW":
		{
			"en":	"Post review"
		,	"es":	"Enviar opinión"
		}
	,	"POST_INSTRUCTIONS":
		{
			"en":	"Post instructions"
		,	"es":	"Enviar instrucciones"
		}
	,	"ALL":
		{
			"en":	"All"
		,	"es":	"Todo"
		}
	,	"COMMENTS":
		{
			"en":	"Comments"
		,	"es":	"Comentarios"
		}
	,	"REVIEWS":
		{
			"en":	"Reviews"
		,	"es":	"Opiniones"
		}
	,	"DOWNLOAD_ATTACHMENT":
		{
			"en":	"Download attachment"
		,	"es":	"Descargar adjunto"
		}
	,	"LOAD_MORE":
		{
			"en":	"Load More"
		,	"es":	"Cargar más"
		}
	,	"VERIFIED_BUYER_MESSAGE":
		{
			"en":	"Include the verified buyer badge next to my name on this comment."
		,	"es":	""
		}
	,	"VERIFIED_BUYER_TOOLTIP":
		{
			"en":	"The verified buyer badge indicates that we have verified that you have purchased and received this set."
		,	"es":	""
		}
	}
);
